import { Injectable } from "@angular/core";
import { AccountAttribute } from "../model/account-attribute.model";
import { RestService } from "../../../services/rest.service";

@Injectable({
  providedIn: 'root'
})
export class AccountAttributeMasterApi {
  public static readonly ApiEndpoint = 'master/account-attribute'

  constructor(private restService: RestService) {
  }

  /**
   * Fetches all account attributes for a given user.
   * @param userId The user ID to fetch account attributes for.
   */
  readAllByUser(userId: string) {
    return this.restService.send<AccountAttribute[]>({
      url: `${AccountAttributeMasterApi.ApiEndpoint}/find-by-user/${userId}`,
      method: 'GET'
    });
  }

  /**
   * Deletes an account attribute by ID.
   * @param attributeId The account attribute ID to delete.
   */
  delete(attributeId: string) {
    return this.restService.send<AccountAttribute>({
      url: `${AccountAttributeMasterApi.ApiEndpoint}/${attributeId}`,
      method: 'DELETE'
    });
  }
}
